import SecureLS from "secure-ls";
import _valid from "../validations";

export default class ApiRest {

    props;
    ls;

    constructor(props) {
        this.props = props;
        this.ls = new SecureLS({encodingType: 'aes'});
    }

    setLS(key, data) {
        this.ls.set(key, data);
    }

    getLS(key) {
        try {
            return this.ls.get(key);
        } catch (error) {
            console.log(error);
        }
        return null;
    }

    asignarEmpresa(key, datos){
        try {
            this.ls.set(key, datos)
        } catch (error) {
            console.log(error)
        }
    }

    getArticuloEmpresa(url){
        let empresa = this.getLS('idEmpresa');
        try {
            return this.get(url+empresa.id);
        } catch (error) {
            console.log(error)
        }
    }

    //verificando solicitudes automaticas
    postVerificarSolicitud() {
        let user = this.getLS('du');
        try {
            this.get('/solicitudConcurrente_detail').then(res => {
                if(res.exitoso){
                    console.log(res);
                }
            });
        } catch (error) {
            console.log(error)
        }
    }

    getEmpresaNombre(){
        if(_valid(this.getLS('idEmpresa'))){
            let empresa = this.getLS('idEmpresa');
            return empresa.nombre;
        }
        return null;
    }

    getColaborador(url){
        let empresa = this.getLS('idEmpresa');
        try {
            return this.get(url+empresa.id);
        } catch (error) {
            console.log(error)
        }
    }

    getUbicacion(url){
        let empresa = this.getLS('idEmpresa');
        try {
            return this.get(url+empresa.id);
        } catch (error) {
            console.log(error)
        }
    }

    getUbicacionPorEmpresa(url){
        try {
            return this.get(url);
        } catch (error) {
            console.log(error)
        }
    }

    getTipoDeSolicitud(url){
        let empresa = this.getLS('idEmpresa');
        try {
            return this.get(url+empresa.id);
        } catch (error) {
            console.log(error)
        }
    }

    getColaboradorLista(url,id){
        
        try {
            return this.get(url+id);
        } catch (error) {
            console.log(error)
        }
    }

    getUsuario(){
        let usuario = this.getLS('du');
        return usuario;
    }

    getRolDeUsuario(nombre){
        let user = this.getLS('du');
        let estado = false;
        if(user){
            user.groups.forEach(rol =>{
                if(rol.name == nombre){
                    estado = true;
                }
            });
        }
        return estado;
    }

    misSolicitudes(url, filtro) {

        this.getUsuario();
        let rolName = null;
        let user = this.getLS('du');
        let estado = false;
        let data = {};
        
        if(!estado){
            rolName = 'ROL_RESPONSABLE_DEPARTAMENTO';
            user.groups.forEach(rol =>{
                if(rol.name == rolName){
                    estado = true;
                }
            });

            if(estado){
                
                data = {
                    idColaborador: user.colaborador.id,
                    rolName: rolName,
                    empresa: this.getLS('idEmpresa').id,
                    fechaFin: _valid(filtro.fechaFin) ? filtro.fechaFin : null,
                    fechaMin: _valid(filtro.fechaMin) ? filtro.fechaMin : null
                }
            }
        }

        if(!estado){
            rolName = 'ROL_COLABORADOR';
            user.groups.forEach(rol =>{
                if(rol.name == rolName){
                    estado = true;
                }
            });

            if(estado){
               
                data = {
                    idColaborador: user.colaborador.id,
                    rolName: rolName,
                    empresa: this.getLS('idEmpresa').id,
                    fechaFin: _valid(filtro.fechaFin) ? filtro.fechaFin : null,
                    fechaMin: _valid(filtro.fechaMin) ? filtro.fechaMin : null
                }
            }
        }

        return this.post(url, data);;
    }

    tienePermiso(permisoName) {
        let usuario = this.getLS('du');
        if (usuario) {
            let permiso;
            usuario.groups.forEach(rol => {
                permiso = rol.permissions.find(permission => {
                    return permission.codename === permisoName
                });
            });
            return (permiso !== undefined && permiso !== null);
        }
        return false;
    }

    getRol(){
        const rolName = 'ROL_ADMIN';
        let user = this.getLS('du');
        let estado = false;
        if(user){
            user.groups.forEach(rol =>{
                if(rol.name == rolName){
                    estado = true;
                }
            });
        }
        return estado;
    }

    get(url) {
        return this.llamadaSinDatos(url, 'GET');
    }

    post(url, data) {
        return this.llamadaConDatos(url, 'POST', data);
    }

    postSinToken(url, data) {
        return this.llamadaConDatosSinToken(url, 'POST', data);
    }

    put(url, data) {
        return this.llamadaConDatos(url, 'PUT', data);
    }

    getWithFiles(url) {
        return this.llamadaConArchivosSinDatos(url, 'GET');
    }

    async postFiles(url, data) {
        return await this.llamadaConArchivosYDatos(url, 'POST', data);
    }

    async putFiles(url, data) {
        return await this.llamadaConArchivosYDatos(url, 'PUT', data);
    }

    delete(url) {
        return this.llamadaSinDatos(url, 'DELETE');
    }

    //metodo para recibir un archivo
    FileReporte(url,data,fileName){
        return this.putFileReporte(url,'PUT',data,fileName);
    }

    putFileReporte = (url,method,data,file) => {
        const auth = this.getLS('authUser');
        if (auth !== null) {
            const headers = {
                method: method,
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                responseType: 'blob',
                body: JSON.stringify(data ? data : '')
            }
            fetch(process.env.REACT_APP_API_URL + url, headers).then(resp => resp.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    a.download = file;
                    document.body.appendChild(a);
                    a.click();
                    return window.URL.revokeObjectURL(url);
                }
            );
        } else {
            this.props.history.push('/Timeout');
        }
    }

    //metodo para obtener imagen del articulo
    async imagenArticulo(url, method,data){
        return await this.imagen(url, method,data)
    }

    imagen = async(url, method,data) => {
        const auth = this.getLS('authUser');
        return await fetch(process.env.REACT_APP_API_URL + url, {
            method: method,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
            body: JSON.stringify(data ? data : '')
        })
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaBase64: dato.imgNuevaBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    //this.props.history.push('/logout');
                    this.props.history.push('/Timeout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    //metodo para obtener un articulo con imagen
    async ArticuloFile(url, data, method) {
        return await this.getArticuloFile(url, method, data);
    }

    async getArticuloFile(url, method, data) {
        const auth = this.getLS('authUser');
        const headers = {
            method: method,
            headers: { 'Authorization': 'Bearer ' + auth.access },
            body: data
        }

        //console.log(headers);

        return await fetch(process.env.REACT_APP_API_URL + url, headers)
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaBase64: dato.imgNuevaBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    //this.props.history.push('/logout');
                    this.props.history.push('/Timeout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    llamadaConDatosSinToken(url, method, data) {
        return new Promise(resolve => {
            const headers = {
                method: method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data ? data : '')
            }

            fetch(process.env.REACT_APP_API_URL + url, headers).then(response => {
                if (response.status >= 200 && response.status < 300) {
                    response.json().then(dato => {
                        resolve({ exitoso: true, data: dato });
                    }).catch(error => {
                        resolve({ exitoso: false, response: response, error: error });
                    });
                } else {
                    response.json().then(dato => {
                        resolve({ exitoso: false, response: response, data: dato });
                    }).catch(error => {
                        resolve({ exitoso: false, response: response, error: error });
                    });
                }
            }).catch(error => {
                resolve({ exitoso: false, error: error });
            });
        });
    }

    llamadaConDatos(url, method, data) {
        return new Promise(resolve => {
            const auth = this.getLS('authUser');
            if (auth != null) {
                const headers = {
                    method: method,
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                    body: JSON.stringify(data ? data : '')
                }

                fetch(process.env.REACT_APP_API_URL + url, headers).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        response.json().then(dato => {
                            resolve({ exitoso: true, data: dato });
                        }).catch(error => {
                            resolve({ exitoso: false, response: response, error: error });
                        });
                    } else if (response.status === 401) {
                        //this.props.history.push('/logout');
                        this.props.history.push('/Timeout');
                    } else {
                        response.json().then(dato => {
                            resolve({ exitoso: false, response: response, data: dato });
                        }).catch(error => {
                            resolve({ exitoso: false, response: response, error: error });
                        });
                    }
                }).catch(error => {
                    resolve({ exitoso: false, error: error });
                });
            } else {
                resolve({ exitoso: false, error: 'Usuario no autenticado' });
            }
        });
    }

    async llamadaConArchivosYDatos(url, method, data) {
        return await fetch(process.env.REACT_APP_API_URL + url, {
            method,
            body: data
        })
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        // .then(dato => {console.log("dato > ", dato); return dato})
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaSolicitudBase64: dato.imgNuevaSolicitudBase64,
                            imgSolicitudTrabajadaBase64: dato.imgSolicitudTrabajadaBase64,
                            imgSolicitudTrabajadaBase64_2: dato.imgSolicitudTrabajadaBase64_2,
                            imgSolicitudTrabajadaBase64_3: dato.imgSolicitudTrabajadaBase64_3,
                            imgCalificacionBase64: dato.imgCalificacionBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    //this.props.history.push('/logout');
                    this.props.history.push('/Timeout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    llamadaSinDatos(url, method) {
        return new Promise(resolve => {
            const auth = this.getLS('authUser');
            if (auth != null) {
                const headers = {
                    method: method,
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                }

                fetch(process.env.REACT_APP_API_URL + url, headers).then(response => {

                    if (response.status >= 200 && response.status < 300) {
                        response.json().then(data => {
                            resolve({ exitoso: true, data: data });
                        }).catch(error => {
                            resolve({ exitoso: false, response: response, error: error });
                        });
                    } else if (response.status === 401) {
                        //this.props.history.push('/logout');
                        this.props.history.push('/Timeout');
                    } else {
                        response.json().then(data => {
                            resolve({ exitoso: false, response: response, data: data });
                        }).catch(error => {
                            resolve({ exitoso: false, response: response, error: error });
                        });
                    }

                }).catch(error => {
                    resolve({ exitoso: false, error: error });
                });
            } else {
                resolve({ exitoso: false, error: 'Usuario no autenticado' });
            }
        });
    }

    llamadaConArchivosSinDatos(url, method) {
        return new Promise(resolve => {
            const auth = this.getLS('authUser');
            if (auth != null) {
                const headers = {
                    method: method,
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                }

                fetch(process.env.REACT_APP_API_URL + url, headers).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        response.json().then(data => {
                            // console.log("sin datos ewfewwfefewfefweewfwef > ", data);
                            resolve({
                                exitoso: true,
                                data: data.datosSerializados,
                                imgNuevaSolicitudBase64: data.imgNuevaSolicitudBase64,
                                imgSolicitudTrabajadaBase64: data.imgSolicitudTrabajadaBase64,
                                imgSolicitudTrabajadaBase64_2: data.imgSolicitudTrabajadaBase64_2,
                                imgSolicitudTrabajadaBase64_3: data.imgSolicitudTrabajadaBase64_3,
                                imagen64: data.imagenEnBase64,
                                imgCalificacionBase64: data.imgCalificacionBase64
                            });
                            // resolve({ exitoso: true, data: data });
                            // resolve({ exitoso: true, data: data.datosSerializados, imagen64: data.imagenEnBase64,imgCalificacionBase64: data.imgCalificacionBase64 });
                        }).catch(error => {
                            resolve({ exitoso: false, response: response, error: error });
                        });
                    } else if (response.status === 401) {
                        //this.props.history.push('/logout');
                        this.props.history.push('/Timeout');
                    } else {
                        response.json().then(data => {
                            resolve({ exitoso: false, response: response, data: data });
                        }).catch(error => {
                            resolve({ exitoso: false, response: response, error: error });
                        });
                    }

                }).catch(error => {
                    resolve({ exitoso: false, error: error });
                });
            } else {
                resolve({ exitoso: false, error: 'Usuario no autenticado' });
            }
        });
    }
}